import { render } from "./master-pdf-legas.vue?vue&type=template&id=2c457ecc"
import script from "./master-pdf-legas.vue?vue&type=script&lang=js"
export * from "./master-pdf-legas.vue?vue&type=script&lang=js"

import "./master-pdf-legas.vue?vue&type=style&index=0&id=2c457ecc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__